import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import { IMGSEARCH, imgSearchCls } from "../../imageSearch.classes";

interface Product {
  id: number;
  img: string;
  barcode: string;
  specialCode: string;
  colorCode: string;
  seasonCode: string;
  productName: string;
  merchAgeGroup: string;
  size: string;
  line: string;
  currentStatus: string;
  productStatus: string;
  setSelectedItems: any[];
  imagePathIndexMetas: {
    uri: string;
  };
}

interface Props {
  products: Product[];
  selectedItems: any[];
  setSelectedItems: React.Dispatch<React.SetStateAction<any[]>>;
}

export const SCUIProductList: React.FC<Props> = ({
  products,
  selectedItems,
  setSelectedItems,
}) => {
  const handleImageClick = (item: any) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter((i) => i !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };
  return (
    <TableContainer className={IMGSEARCH.productListPaper} component={Paper}>
      <Table className={IMGSEARCH.productListTable}>
        <TableHead>
          <TableRow>
            <TableCell>Image</TableCell>
            <TableCell>Barcode</TableCell>
            <TableCell>Special Code</TableCell>
            <TableCell>Color Code</TableCell>
            <TableCell>Season Code</TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Merge Age Group</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Line</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product) => (
            <TableRow
              key={product.id}
              onClick={() => handleImageClick(product)}
            >
              <div
                onClick={() => handleImageClick(product)}
                className={imgSearchCls("makeAvatarImageBigger", IMGSEARCH.productImageCell)}
                style={{
                  width: 100,
                  height: 100,
                  display: "inline-block",
                  verticalAlign: "top",
                  transition: "transform 0.3s ease",
                  overflow: "-moz-hidden-unscrollable",
                  margin: "10px", // Boşluk bırakmak için margin ekledik
                  position: "relative",
                }}
              >
                <Checkbox
                  className={IMGSEARCH.productRowCheckbox}
                  checked={selectedItems.includes(product)}
                  onChange={() => handleImageClick(product)}
                  style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem",
                    zIndex: 1,
                  }}
                />
                <img
                  src={product.imagePathIndexMetas.uri}
                  alt="Product"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>

              <TableCell>{product.barcode}</TableCell>
              <TableCell>{product.specialCode}</TableCell>
              <TableCell>{product.colorCode}</TableCell>
              <TableCell>{product.seasonCode}</TableCell>
              <TableCell>{product.productName}</TableCell>
              <TableCell>{product.merchAgeGroup}</TableCell>
              <TableCell>{product.size}</TableCell>
              <TableCell>{product.line}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
